import React, { Component } from 'react'
import PropTypes from 'prop-types'

import AssignmentAvatars from './AssignmentAvatars'
import MarkdownLabel from './MarkdownLabel'

import {
  getDateDisplay,
  getDifferenceInMinutesToNow,
  getDaysAgoFromMinutes
} from '../../utils/time'
import { ago } from '../../utils/messages'
import { getUserDisplayName } from '../../utils/name'

export default class QuestListItemAssignment extends Component {
  render() {
    const {
      assignedBy,
      assignedTo,
      message,
      updatedAt,
      clickHandler,
      questIsAssignedToUser,
      questIsAssignedByUser,
      assignmentType
    } = this.props

    const firstString = questIsAssignedByUser
      ? '<strong>You</strong>'
      : getUserDisplayName(assignedBy)

    const lastString = questIsAssignedToUser
      ? '<strong>you</strong>'
      : getUserDisplayName(assignedTo)

    const fullMessage =
      assignmentType === 'rejection'
        ? `${getUserDisplayName(
            assignedBy
          )} returned this quest from Publication Review.`
        : `${firstString} assigned this quest to ${lastString}.`

    return (
      <div className="quest-list-item-assignment" onClick={clickHandler}>
        {assignedBy && assignedTo && (
          <div className="assignment-top">
            <div className="left">
              <AssignmentAvatars
                fromPhotoUrl={assignedBy.photo_url}
                toPhotoUrl={assignedTo.photo_url}
              />
            </div>
            <div className="middle">
              <div
                className="assignment-info caption1"
                dangerouslySetInnerHTML={{ __html: fullMessage }}
              ></div>
            </div>
            <div className="right">
              <div className="caption1 date">
                {getDateDisplay(updatedAt, true)}
                {getDaysAgoFromMinutes(
                  getDifferenceInMinutesToNow(updatedAt)
                ) <= 7 && <span>&nbsp;{ago}</span>}
              </div>
            </div>
          </div>
        )}
        {message && (
          <div className="assignment-bottom">
            <div className="left" />
            <div className="middle">
              <div className="caption1 assignment-message">
                {assignmentType === 'rejection' ? (
                  <MarkdownLabel value={message} />
                ) : (
                  message
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    )
  }
}

QuestListItemAssignment.propTypes = {
  assignedBy: PropTypes.object.isRequired,
  assignedTo: PropTypes.object.isRequired,
  message: PropTypes.string,
  updatedAt: PropTypes.number.isRequired,
  clickHandler: PropTypes.func.isRequired,
  questIsAssignedToUser: PropTypes.bool.isRequired,
  questIsAssignedByUser: PropTypes.bool.isRequired,
  assignmentType: PropTypes.string
}



// WEBPACK FOOTER //
// ./src/components/mini/QuestListItemAssignment.js